var app = angular.module("leonardo");

var TaskDynamicFormDialog = function ($scope, $filter, $timeout, $q, $rootScope, ngDialog, $builder, $validator,
    formObj, formDataObj, DynamicFormDataRestService, FilterService, FormErrorsService,
    AttachmentService, TaskService, PropertyService, FileService, AuthService,
    UnitService, $interval) {
        // This is intentional do_something blank function
};

app.controller('TaskDynamicFormDialog', ['$scope', '$filter', '$timeout', '$q', '$rootScope', 'ngDialog', '$builder',
    '$validator', 'formObj', 'formDataObj', 'DynamicFormDataRestService', 'FilterService', 'FormErrorsService',
    'AttachmentService', 'TaskService', 'PropertyService', 'FileService', 'AuthService', 'UnitService', '$interval',
    TaskDynamicFormDialog]);
